import { CultureInfo } from '../culture-info.model';
import { CultureInfoMas } from './mas';

/**
 * @ignore
 */
export const CultureInfoMasTZ: CultureInfo = {
  name: 'mas-TZ',
  displayName: 'Maa (Tansania)',
  iso3LanguageCode: 'mas',
  iso2LanguageCode: 'mas',
  ietfLanguageTag: 'mas-TZ',
  parent: CultureInfoMas
};
